/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".invite-faculty-dialog[_ngcontent-%COMP%]{max-width:900px}.invite-faculty-dialog-form[_ngcontent-%COMP%]{height:200px;overflow-y:scroll}"];
export { styles as styles };

